import { DatadogRumWrapper } from '@newfront-insurance/dd-rum';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import * as React from 'react';
import type { JSX } from 'react';

interface Props {
  children: React.ReactNode;
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
}

export function DatadogWrapper({ children, authProvider }: Props): JSX.Element {
  return <DatadogRumWrapper authProvider={authProvider}>{children as JSX.Element}</DatadogRumWrapper>;
}
